module.exports = __webpack_public_path__ + "img/fk.f2546e12.svg";